module.exports = __webpack_public_path__ + "static/media/location.8bd0a212.svg";